import styles from "./backdrop.module.css";

const Backdrop = props => {
	const cssClasses = [styles.Backdrop, props.show ? styles.BackdropOpen : styles.BackdropClosed];

	return <div className={cssClasses.join(" ")} onClick={props.clicked}></div>;
};

export default Backdrop;
